import React from 'react'
import {Field, reduxForm, getFormValues, FieldArray} from 'redux-form'
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import {
    Alert, Button, Card,CardBody,Col, FormGroup, FormText, Label,
    Row
} from "reactstrap";
import renderField from "./renderField";
import renderCheck from "./renderCheck";
import renderFile from "./renderFile";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import DateField from "./renderDate";
import normalizePhone from "./normalizePhone";
import renderTextarea from "./renderTextarea";
import renderSelect from "./renderSelect";

const required = value => value ? undefined : 'Merci de remplir ce champ';
const fileMinSize = 4 * 1024 * 1024;
const fileSize = value => (value.size >= fileMinSize) ? undefined : 'Le fichier doit faire moins de 4MB';


const validate = values => {
    const errors = {}

    if (values.vousetes && values.vousetes != "resp") {
        if(!values.procuration){
            errors.procuration ='Merci de remplir ce champ'
        } else {
            if(values.procuration.size >= fileMinSize){
                errors.procuration ='Le fichier doit faire moins de 4MB'
            }
        }
    }

    if (values.typesoc && values.typesoc == "dem") {
        if(!values.rib){
            errors.rib ='Merci de remplir ce champ'
        }else {
            if(values.rib.size >= fileMinSize){
                errors.rib ='Le fichier doit faire moins de 4MB'
            }
        }

        if(!values.status2){
            errors.status2 ='Merci de remplir ce champ'
        }else {
            if(values.status2.size >= fileMinSize){
                errors.status2 ='Le fichier doit faire moins de 4MB'
            }
        }

        if(!values.kbis){
            errors.kbis ='Merci de remplir ce champ'
        }else {
            if(values.kbis.size >= fileMinSize){
                errors.kbis ='Le fichier doit faire moins de 4MB'
            }
        }
        console.log(errors);
        if(!values.siret){
            errors.siret ='Merci de remplir ce champ'
        }
    }


    if (values.nomComCheck && values.nomComCheck == "oui") {
        if(!values.nomCom){
            errors.nomCom ='Merci de remplir ce champ'
        }
    }



    if (values.vousetes && values.vousetes == "int") {

        if(!values.intinfonom){
            errors.intinfonom ='Merci de remplir ce champ'
        }
        if(!values.intinfosociete){
            errors.intinfosociete ='Merci de remplir ce champ'
        }
        if(!values.intinfoemail){
            errors.intinfoemail ='Merci de remplir ce champ'
        }
        if(!values.intinfoville){
            errors.intinfoville ='Merci de remplir ce champ'
        }
        if(!values.intinfopostal){
            errors.intinfopostal ='Merci de remplir ce champ'
        }
        if(!values.intinfoaddr){
            errors.intinfoaddr ='Merci de remplir ce champ'
        }
        if(!values.intinfophone){
            errors.intinfophone ='Merci de remplir ce champ'

        }else if(values.intinfophone.length != 14){
            errors.intinfophone ='Numéro de téléphone invalide'
        }
    }

    if (values.repres && values.repres == "physique") {

        if(!values.moralinnom){
            errors.moralinnom ='Merci de remplir ce champ'
        }
        if(!values.moralinprenom){
            errors.moralinprenom ='Merci de remplir ce champ'
        }
        if(!values.moralinfonction){
            errors.moralinfonction ='Merci de remplir ce champ'
        }
        if(!values.moralinemail){
            errors.moralinemail ='Merci de remplir ce champ'
        }
        if(!values.moralinaddr){
            errors.moralinaddr ='Merci de remplir ce champ'
        }
        if(!values.moralinpostal){
            errors.moralinpostal ='Merci de remplir ce champ'
        }
        if(!values.moralinville){
            errors.moralinville ='Merci de remplir ce champ'
        }
        if(!values.moralinmobile){
            errors.moralinmobile ='Merci de remplir ce champ'
        }else if(values.moralinmobile.length != 14){
            errors.intinfophone ='Numéro de téléphone invalide'
        }
        if(!values.moralinid1){
            errors.moralinid1 ='Merci de remplir ce champ'
        }else {
            if(values.moralinid1.size >= fileMinSize){
                errors.moralinid1 ='Le fichier doit faire moins de 4MB'
            }
        }
        if(!values.moralinid2){
            errors.moralinid2 ='Merci de remplir ce champ'
        }else {
            if(values.moralinid2.size >= fileMinSize){
                errors.moralinid2 ='Le fichier doit faire moins de 4MB'
            }
        }

        if(!values.moralinid3){
            errors.moralinid3 ='Merci de remplir ce champ'
        }else {
            if(values.moralinid3.size >= fileMinSize){
                errors.moralinid3 ='Le fichier doit faire moins de 4MB'
            }
        }
        if(!values.moralinid4){
            errors.moralinid4 ='Merci de remplir ce champ'
        }else {
            if(values.moralinid4.size >= fileMinSize){
                errors.moralinid4 ='Le fichier doit faire moins de 4MB'
            }
        }
        if(!values.moralindomi){
            errors.moralindomi ='Merci de remplir ce champ'
        }else {
            if(values.moralindomi.size >= fileMinSize){
                errors.moralindomi ='Le fichier doit faire moins de 4MB'
            }
        }

    }

    if (values.repres && values.repres == "moral") {

        if(!values.physinraison){
            errors.physinraison ='Merci de remplir ce champ'
        }
        if(!values.physinnom){
            errors.physinnom ='Merci de remplir ce champ'
        }
        if(!values.physinprenom){
            errors.physinprenom ='Merci de remplir ce champ'
        }
        if(!values.physinrcs){
            errors.physinrcs ='Merci de remplir ce champ'
        }
        if(!values.physinactivite){
            errors.physinactivite ='Merci de remplir ce champ'
        }
        if(!values.physinemail){
            errors.physinemail ='Merci de remplir ce champ'
        }
        if(!values.physinadresse){
            errors.physinadresse ='Merci de remplir ce champ'
        }
        if(!values.physinville){
            errors.physinville ='Merci de remplir ce champ'
        }
        if(!values.physinpostal){
            errors.physinpostal ='Merci de remplir ce champ'
        }
        if(!values.physinphone){
            errors.physinphone ='Merci de remplir ce champ'
        }else if(values.physinphone.length != 14){
            errors.intinfophone ='Numéro de téléphone invalide'
        }

        if(!values.physinstatus){
            errors.physinstatus ='Merci de remplir ce champ'
        }else {
            if(values.physinstatus.size >= fileMinSize){
                errors.physinstatus ='Le fichier doit faire moins de 4MB'
            }
        }
        if(!values.physinkbis){
            errors.physinkbis ='Merci de remplir ce champ'
        }else {
            if(values.physinkbis.size >= fileMinSize){
                errors.physinkbis ='Le fichier doit faire moins de 4MB'
            }
        }
        if(!values.physinid1){
            errors.physinid1 ='Merci de remplir ce champ'
        }else {
            if(values.physinid1.size >= fileMinSize){
                errors.physinid1 ='Le fichier doit faire moins de 4MB'
            }
        }
        if(!values.physinid2){
            errors.physinid2 ='Merci de remplir ce champ'
        }else {
            if(values.physinid2.size >= fileMinSize){
                errors.physinid2 ='Le fichier doit faire moins de 4MB'
            }
        }

        if(!values.physinid3){
            errors.physinid3 ='Merci de remplir ce champ'
        }else {
            if(values.physinid3.size >= fileMinSize){
                errors.physinid3 ='Le fichier doit faire moins de 4MB'
            }
        }
        if(!values.physinid4){
            errors.physinid4 ='Merci de remplir ce champ'
        }else {
            if(values.physinid4.size >= fileMinSize){
                errors.physinid4 ='Le fichier doit faire moins de 4MB'
            }
        }
    }
    return errors
}
const  displayError = (submitFailed) => {

    if (submitFailed){

        return (
            <Alert color="danger">
                Le formulaire contient des erreurs
            </Alert>
        );
    }

}

const SecondStep = props => {
    let { handleSubmit, formValues, previous, submitFailed } = props;
    if(!formValues){
        formValues = {};
    }

    return (
        <form onSubmit={handleSubmit}>
            {displayError(submitFailed)}
            <FormGroup tag="fieldset">
                <legend style={{textDecoration: "underline"}}>3/ Vous êtes ?</legend>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                        <FormGroup check>
                            <Field name="vousetes" type="radio" value="resp" label="Le représentant légal" component={renderCheck} style={{"margin": "0 0 0 0"}} validate={required}/>
                        </FormGroup>
                        <FormGroup check>
                            <Field name="vousetes" type="radio" value="asso" label="Un associé" style={{"margin": "0 0 0 0"}} component={renderCheck} validate={required}/>
                        </FormGroup>
                        <FormGroup check>
                            <Field name="vousetes" type="radio" value="int" label="Un intermédiaire	(Avocat, expert-comptable…)" style={{"margin": "0 0 0 0"}} component={renderCheck} validate={required}/>
                        </FormGroup>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset" hidden={!formValues.vousetes || formValues.vousetes != "int"}>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                        <FormGroup>
                            <Label>Société</Label>
                            <Field name="intinfosociete" type="text" component={renderField}/>
                        </FormGroup>
                <FormGroup>
                    <Label>Nom</Label>
                    <Field name="intinfonom" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Email</Label>
                    <Field name="intinfoemail" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Téléphone</Label>
                    <Field name="intinfophone" type="text" component={renderField} normalize={normalizePhone}/>
                </FormGroup>
                <FormGroup>
                    <Label>Adresse</Label>
                    <Field name="intinfoaddr" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Code Postal</Label>
                    <Field name="intinfopostal" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Ville</Label>
                    <Field name="intinfoville" type="text" component={renderField}/>
                </FormGroup>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset" hidden={!formValues.vousetes || formValues.vousetes == "resp"}>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                <FormGroup>
                            <Field name="procuration" placeholder="Télécharger votre procuration (4MB max)" component={renderFile}/>
                </FormGroup>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset">
                <legend style={{textDecoration: "underline"}}>4/ La société à domicilier est :</legend>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                <FormGroup check>
                    <Field name="typesoc" type="radio" value="crea" label="En création" component={renderCheck} style={{"margin": "0 0 0 0"}} validate={required}/>
                </FormGroup>
                <FormGroup check>
                    <Field name="typesoc" type="radio" value="dem" label="En déménagement" component={renderCheck} style={{"margin": "0 0 0 0"}} validate={required}/>
                </FormGroup>
                    </Col>
                </Row>
             </FormGroup>
            <FormGroup tag="fieldset" hidden={!formValues.typesoc || formValues.typesoc == "dem"}>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                <FormGroup>
                    <Field name="status" placeholder="Télécharger vos statuts constitutifs (4MB max)" component={renderFile}/>
                </FormGroup>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset" hidden={!formValues.typesoc || formValues.typesoc == "crea"}>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                        <FormGroup>
                            <Row>
                                <Col xs="12">
                                    <Label>SIRET</Label>
                                    <Field name="siret" type="text" component={renderField}/>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col xs="12">
                                    <Field name="status2" placeholder="Télécharger vos statuts (4MB max)" component={renderFile}/>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col xs="12">
                                    <Field name="kbis" placeholder="Télécharger vos KBIS (4MB max)" component={renderFile}/>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset">
                <legend style={{textDecoration: "underline"}}>5/ L'établissement à domicilier est :</legend>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                <FormGroup check>
                    <Field name="etaDomic" type="radio" value="social" label="Le siège social" component={renderCheck} style={{"margin": "0 0 0 0"}} validate={required}/>
                </FormGroup>
                <FormGroup check>
                    <Field name="etaDomic" type="radio" value="second" label="Un établissement secondaire" component={renderCheck} style={{"margin": "0 0 0 0"}} validate={required}/>
                </FormGroup>
                <FormText color="muted">
                    *Pour domicilier un établissement secondaire, le siège social de la meme entreprise doit dépendre du meme Greffe soit Evry
                </FormText>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset">
                <legend style={{textDecoration: "underline"}}>6/ Quel est le nom juridique de l'entreprise à domicilier :</legend>
                <Row>
                    <Col xs={{size:11, offset:1}}>

                <Field name="nomjuridique" type="text" component={renderField} validate={required} placeholder=""/>
                <Label>L'entreprise a t'elle un nom comerciale ?</Label>
                <Field name="nomComCheck" component={renderSelect} className="form-control">
                    <option value="non" label="Non">Non</option>
                    <option value="oui" label="Oui">Oui</option>
                </Field>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset" hidden={!formValues.nomComCheck || formValues.nomComCheck != "oui"}>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                <Label>Nom commerciale : </Label>
                <Field name="nomCom" type="text" component={renderField} placeholder=""/>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset">
                <legend style={{textDecoration: "underline"}}>7/ Quel est le statut juridique de votre entreprise ?</legend>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                <Field name="statutJuri" component={renderSelect} className="form-control" validate={required}>
                    <option></option>
                    <option value="asso" label="Association">Association</option>
                    <option value="ae" label="Auto-entrepreneur">Auto-entrepreneur</option>
                    <option value="ei" label="Entreprise individuelle">Entreprise individuelle</option>
                    <option value="eurl" label="EURL" >EURL</option>
                    <option value="sa" label="SA" >SA</option>
                    <option value="sarl" label="SARL">SARL</option>
                    <option value="sas" label="SAS" >SAS</option>
                    <option value="sasu" label="SASU" >SASU</option>
                    <option value="sci" label="SCI" >SCI</option>
                    <option value="snc" label="SNC" >SNC</option>
                </Field>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset">
                <legend style={{textDecoration: "underline"}}>8/ Informations sur la société à domicilier</legend>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                <FormGroup check>
                    <Label>Quel va être/est votre secteur d’activité </Label><br />
                    <Field name="secteur" component={renderSelect} className="form-control" validate={required}>
                        <option></option>
                        <option value="Administration, fonction publique">Administration, fonction publique</option>
                        <option value="Agroalimentaire">Agroalimentaire</option>
                        <option value="Artisanat d'art">Artisanat d'art</option>
                        <option value="Associations">Associations</option>
                        <option value="Banques, assurances, services financiers">Banques, assurances, services financiers</option>
                        <option value="Chimie, plastique, conditionnement">Chimie, plastique, conditionnement</option>
                        <option value="Commerce de détail, grande distribution">Commerce de détail, grande distribution</option>
                        <option value="Communication, marketing, information">Communication, marketing, information</option>
                        <option value="Construction, bâtiment, travaux publics">Construction, bâtiment, travaux publics</option>
                        <option value="Culture, sports, loisirs">Culture, sports, loisirs</option>
                        <option value="Energie">Energie</option>
                        <option value="Enseignement, formation">Enseignement, formation</option>
                        <option value="Environnement, récupération, tri, recyclage, traitement des déchets, matériaux, ...">Environnement, récupération, tri, recyclage, traitement des déchets, matériaux, ...</option>
                        <option value="Equipement, matériel pour des activités professionnelles">Equipement, matériel pour des activités professionnelles</option>
                        <option value="Fabrication, commerce de gros d'articles destinés à la vente">Fabrication, commerce de gros d'articles destinés à la vente</option>
                        <option value="Gestion, administration des entreprises">Gestion, administration des entreprises</option>
                        <option value="Hôtellerie, restauration, tourisme">Hôtellerie, restauration, tourisme</option>
                        <option value="Immobilier">Immobilier</option>
                        <option value="Industrie textile">Industrie textile</option>
                        <option value="Informatique">Informatique</option>
                        <option value="Ingénieurs d'études et de recherche, chercheurs">Ingénieurs d'études et de recherche, chercheurs</option>
                        <option value="Logistique, transports">Logistique, transports</option>
                        <option value="Matériel électrique, électronique, optique">Matériel électrique, électronique, optique</option>
                        <option value="Mécanique, métallurgie">Mécanique, métallurgie</option>
                        <option value="Minerais, minéraux, sidérurgie">Minerais, minéraux, sidérurgie</option>
                        <option value="Professions juridiques">Professions juridiques</option>
                        <option value="Santé, action sociale">Santé, action sociale</option>
                        <option value="Services aux particuliers, collectivités, entreprises">Services aux particuliers, collectivités, entreprises</option>
                    </Field>
                </FormGroup>
                <FormGroup >
                    <Label>Activité</Label>
                    <Field name="descactivi" type="textarea" component={renderTextarea} className="form-control" validate={required}/>
                    <FormText color="muted">
                        Décrivez en quelques mots le métier de votre entreprise
                    </FormText>
                </FormGroup>
                <FormGroup check>
                    <Label>Capital en €</Label>
                    <Field name="capital" type="text" component={renderField} validate={required} placeholder=""/>
                    <FormText color="muted">
                        Montant des ressources financières apportée à l’entreprise pour sa création
                    </FormText>
                </FormGroup>
                <FormGroup check>
                    <Label>Clientèle</Label><br />
                    <Field name="clienteleentreprises" type="checkbox" label={<span>Entreprises</span>} component={renderCheck}/>
                </FormGroup>
                <FormGroup check>
                    <Field name="clienteleparticulier" type="checkbox" label={<span>Particuliers</span>} component={renderCheck}/>
                </FormGroup>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset">
                <legend style={{textDecoration: "underline"}}>9/ Le représentant légal est :</legend>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                <FormGroup check>
                    <Field name="repres" type="radio" value="moral" label="Une personne morale" component={renderCheck} validate={required}/>
                </FormGroup>
                <FormGroup check>
                    <Field name="repres" type="radio" value="physique" label="Une personne physique" component={renderCheck} validate={required}/>
                </FormGroup>
                <FormText color="muted">
                    La personne morale doit être distinguée de la personne physique. La personne physique désigne un individu, alors que la personne morale est entité qui peut être une entreprise, ou une organisation..
                </FormText>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset" hidden={!formValues.repres || formValues.repres == "moral"}>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                <FormGroup>
                    <Label>Nom</Label>
                    <Field name="moralinnom" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Prénom</Label>
                    <Field name="moralinprenom" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Fonction dans l'entreprise</Label>
                    <Field name="moralinfonction" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Email</Label>
                    <Field name="moralinemail" type="email" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Adresse personnelle</Label>
                    <Field name="moralinaddr" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Code Postal</Label>
                    <Field name="moralinpostal" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Ville</Label>
                    <Field name="moralinville" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Téléphone mobile personnel</Label>
                    <Field name="moralinmobile" type="text" component={renderField} normalize={normalizePhone}/>
                </FormGroup>
                <FormGroup>
                    <Label>Téléphone fixe personnel</Label>
                    <Field name="moralinfix" type="text" component={renderField} normalize={normalizePhone}/>
                </FormGroup>
                <FormGroup>
                    <Label>Détention du nombre de part du capital social (%)</Label>
                    <Field name="moralinpart" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Pièces Justificatives</Label>
                    <Field name="moralinid1" placeholder="Pièce d'identité recto (couleur obligatoire, 4MB max)" component={renderFile}/>
                    <Field name="moralinid2" placeholder="Pièce d'identité verso (couleur obligatoire, 4MB max)" component={renderFile}/>
                    <Field name="moralinid3" placeholder="Seconde pièce d'identité recto (couleur obligatoire, 4MB max)" component={renderFile}/>
                    <Field name="moralinid4" placeholder="Seconde pièce d'identité verso (couleur obligatoire, 4MB max)" component={renderFile}/>
                    <Field name="moralindomi" placeholder="Facture de téléphone mobile de moins de 3 mois (couleur obligatoire, 4MB max)" component={renderFile}/>
                </FormGroup>
                    </Col>
                </Row>
            </FormGroup>
            <FormGroup tag="fieldset" hidden={!formValues.repres || formValues.repres == "physique"}>
                <Row>
                    <Col xs={{size:11, offset:1}}>
                <FormGroup>
                    <Label>Raison Sociale</Label>
                    <Field name="physinraison" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Nom représentant légal</Label>
                    <Field name="physinnom" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Prénom représentant légal</Label>
                    <Field name="physinprenom" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>RCS</Label>
                    <Field name="physinrcs" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Activité</Label>
                    <Field name="physinactivite" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Email</Label>
                    <Field name="physinemail" type="email" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Adresse</Label>
                    <Field name="physinadresse" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Code Postal</Label>
                    <Field name="physinpostal" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Ville</Label>
                    <Field name="physinville" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Téléphone</Label>
                    <Field name="physinphone" type="text" component={renderField} normalize={normalizePhone}/>
                </FormGroup>
                <FormGroup>
                    <Label>Détention du nombre de part du capital social (%)</Label>
                    <Field name="physinpart" type="text" component={renderField}/>
                </FormGroup>
                <FormGroup>
                    <Label>Pièces Justificatives</Label>
                    <Field name="physinkbis" placeholder="KBIS (4MB max)" component={renderFile}/>
                    <Field name="physinstatus" placeholder="Statut (4MB max)" component={renderFile}/>
                    <Field name="physinid1" placeholder="Pièce d'identité recto du représentant légal (couleur obligatoire, 4MB max)" component={renderFile}/>
                    <Field name="physinid2" placeholder="Pièce d'identité verso du représentant légal (couleur obligatoire, 4MB max)" component={renderFile}/>
                    <Field name="physinid3" placeholder="Seconde pièce d'identité recto du représentant légal (couleur obligatoire, 4MB max)" component={renderFile}/>
                    <Field name="physinid4" placeholder="Seconde pièce d'identité verso du représentant légal (couleur obligatoire, 4MB max)" component={renderFile}/>
                    <Field name="physindomi" placeholder="Facture de téléphone mobile de moins de 3 mois du représentant légal (couleur obligatoire, 4MB max)" component={renderFile}/>
                </FormGroup>
                    </Col>
                </Row>
            </FormGroup>
            <div>
                <Button onClick={previous}>
                    Retour
                </Button>
                <Button type="submit" className="float-right">
                    Prochaine Etape
                </Button>
            </div>
        </form>
    )
}

function mapStateToProps(state) {
    return {
        formValues: getFormValues('wizard')(state),
    }
}


export default connect(mapStateToProps,null)(reduxForm({
    form: 'wizard', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
    onSubmitFail: (errors) => window.scrollTo(0, 0),
})(SecondStep));


// WEBPACK FOOTER //
// ./src/SecondStep.js